import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { ClockWidgetComponent } from './clock-widget/clock-widget.component';
import { WINDOW_PROVIDERS } from './providers/window.providers';

@NgModule({ declarations: [ClockWidgetComponent],
    exports: [
        ClockWidgetComponent
    ], imports: [CommonModule,
        FontAwesomeModule,
        SharedModule], providers: [
        WINDOW_PROVIDERS,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
